import React, { createContext, useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { getCurrentPope } from "services/services";

export async function getPope(setState) {
  setState((state) => ({ ...state, loading: true }));
  const response = await getCurrentPope();
  setState((state) => ({ ...state, popeProfile: response, loading: false }));
}


const initialState = {
    popeProfile: null,
    loading: false,
    error: null,
}

export const PopeContext = createContext(null);

export const PopeState = ({ children }) => {
  const [state, setState] = useState(initialState);
  const { t } = useTranslation();

  useEffect(() => {
    getPope(setState);
  }, [t]);

  return (
    <PopeContext.Provider value={state}>
    {children}
  </PopeContext.Provider>
  )
};

export const useStatePope = () => useContext(PopeContext);
